import type { FormErrors } from '@mantine/form'
import type { ZodType } from 'zod'

export const zodResolver = (schema: ZodType) => (values: unknown) => {
  const parsed = schema.safeParse(values)
  const errors: FormErrors = {}

  if (!parsed.success) {
    parsed.error.issues.forEach((error) => {
      errors[error.path.join('.')] = error.message
    })
  }

  return errors
}
